import classNames from 'classnames';
import s from './IdentificationStatusEmpty.module.scss';

export default function IdentificationStatusEmpty() {
  return (
    <>
      <div className={s.status}>
        <div className={classNames([s.loadingShimmer, s.icon])} />
        <div className={s.content}>
          <div className={classNames([s.loadingShimmer, s.title])} />
          <div className={classNames([s.loadingShimmer, s.text])} />
          <div className={classNames([s.loadingShimmer, s.text])} />
          <div className={classNames([s.loadingShimmer, s.text])} />
        </div>
      </div>
      <div className={classNames([s.button, s.loadingShimmer])} />
    </>
  );
}
